import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCommandPalette } from "@/state/CommandPaletteContext";
import { CORE_FEATURES } from "@/lib/coreFeatures";
import { Icon } from "../ui/Icon";

const ITEMS = [
  ...CORE_FEATURES.map((feature) => ({ title: feature.name, sub: feature.short, icon: feature.icon, to: feature.to })),
  { title: "工作台", sub: "选择论文、图片或原始数据", icon: "layout", to: "/app" },
  { title: "我的记录", sub: "查看已保存的结果", icon: "clock", to: "/app/history" },
  { title: "账户与积分", sub: "余额、充值与积分流水", icon: "user", to: "/app/account" },
  { title: "使用说明", sub: "核查范围、报告解读与计费", icon: "book", to: "/app/guide" },
  { title: "个人设置", sub: "报告内 AI 解读的默认深度", icon: "sliders", to: "/app/settings" },
];

export function CommandPalette() {
  const { isOpen, close } = useCommandPalette();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [active, setActive] = useState(0);
  const inputRef = useRef<HTMLInputElement>(null);
  const priorFocus = useRef<HTMLElement | null>(null);
  useEffect(() => {
    if (!isOpen) return;
    priorFocus.current = document.activeElement as HTMLElement | null;
    setQuery("");
    setActive(0);
    const frame = requestAnimationFrame(() => inputRef.current?.focus());
    return () => {
      cancelAnimationFrame(frame);
      priorFocus.current?.focus();
    };
  }, [isOpen]);
  const results = ITEMS.filter((item) => (item.title + item.sub).includes(query.trim()));
  function go(to: string) { close(); navigate(to); }
  if (!isOpen) return null;
  return (
    <div className="cmdk-overlay" onClick={close}>
      <div className="cmdk-panel" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-label="快速跳转"
        onKeyDown={(event) => {
          if (event.key === "Escape") close();
          if (event.key === "Tab") { event.preventDefault(); inputRef.current?.focus(); }
        }}>
        <div className="cmdk-input-row">
          <Icon name="search" size={17} />
          <input ref={inputRef} value={query} aria-label="搜索核查入口" placeholder="搜索核查、记录或账户…"
            onChange={(event) => { setQuery(event.target.value); setActive(0); }}
            onKeyDown={(event) => {
              if (event.key === "ArrowDown") { event.preventDefault(); setActive((index) => Math.min(index + 1, Math.max(0, results.length - 1))); }
              if (event.key === "ArrowUp") { event.preventDefault(); setActive((index) => Math.max(0, index - 1)); }
              if (event.key === "Enter" && results[active]) go(results[active].to);
            }} />
          <kbd>Esc</kbd>
        </div>
        <div className="cmdk-results">
          {results.length === 0 && <p className="cmdk-empty">没有匹配入口，可从工作台选择核查材料。</p>}
          {results.map((item, index) => (
            <button type="button" key={item.to} className={"cmdk-item" + (active === index ? " active" : "")}
              onMouseEnter={() => setActive(index)} onClick={() => go(item.to)} style={{ width: "100%", textAlign: "left", border: 0 }}>
              <Icon name={item.icon} size={16} />
              <span><span className="title">{item.title}</span><span className="sub">{item.sub}</span></span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
